var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.labelKey)?_c('Badge',{staticClass:"whitespace-nowrap",attrs:{"color":"subtle","variant":"statusTag"}},[(_vm.iconComponent)?_c(_vm.iconComponent,{tag:"component",staticClass:"flex-shrink-0",attrs:{"size":14}}):_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t(_vm.labelKey)))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }